import { useQuery } from "@tanstack/react-query";
import type { DashboardOverview } from "@arc/contracts";
import type { AuthSession } from "../../auth/keycloak.js";
import { dashboardApi } from "../../api/client.js";

/**
 * `GET /dashboard/overview` (ADR-033): the Übersicht numbers. Fresh for a minute, then refetched when the tab regains
 * focus (set explicitly — the app's QueryClient default is `refetchOnWindowFocus: false`, and a summary page is
 * exactly where coming back should show today's counts) — no polling.
 */
export function useDashboardOverview(session: AuthSession | null) {
  return useQuery<DashboardOverview, Error>({
    queryKey: ["dashboard-overview", session?.realm, session?.sub],
    enabled: session !== null,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    queryFn: async () => {
      const res = await dashboardApi.getOverview();
      if (res.status !== 200) throw new Error(`GET /dashboard/overview returned ${res.status}`);
      return res.body;
    },
  });
}
